import React from 'react';

const Footer = () => (
  <footer className="pt-4 pb-4 text-center">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <p>&copy; 2024 Scoracle. All rights reserved.</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
